module.exports = __webpack_public_path__ + "img/EQULIZER.709d4fdb.svg";